import React from "react";
import { GlobalButton } from "../../../global/forms/GlobalFormFields";
import { formatDetailDate } from "../utils/notificationFormatters";
import NotificationMessageBody from "./NotificationMessageBody";

export default function NotificationDetailView({ item, onBack, showBack }) {
  if (!item) {
    return (
      <div className="notif-detail notif-detail--empty">
        <p>Select a notification to read</p>
      </div>
    );
  }

  const subject = item.subject || "Notification";
  const message = String(item.notification_message ?? "");

  return (
    <article className="notif-detail" aria-labelledby="notif-detail-subject">
      {showBack ? (
        <div className="notif-detail__toolbar">
          <GlobalButton type="button" variant="ghost" size="sm" onClick={onBack}>
            ← Back to inbox
          </GlobalButton>
        </div>
      ) : null}

      <header className="notif-detail__head">
        <p className="notif-detail__subject" id="notif-detail-subject">
          {subject}
        </p>
        <p className="notif-detail__meta">
          <span className="notif-detail__from">Giri Nestham</span>
          <span className="notif-detail__sep" aria-hidden>
            ·
          </span>
          <time dateTime={item.created_at || undefined}>
            {formatDetailDate(item.created_at)}
          </time>
        </p>
      </header>

      <div className="notif-detail__body">
        <NotificationMessageBody message={message} />
      </div>
    </article>
  );
}
